import { render, staticRenderFns } from "./lclBySeaData.vue?vue&type=template&id=5adc3102&scoped=true"
import script from "./lclBySeaData.vue?vue&type=script&lang=js"
export * from "./lclBySeaData.vue?vue&type=script&lang=js"
import style0 from "./lclBySeaData.vue?vue&type=style&index=0&id=5adc3102&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adc3102",
  null
  
)

export default component.exports